var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('profile-basic-data-card',{attrs:{"readonly":_vm.readonly},on:{"update-email":_vm.emailUpdated}}),_vm._v(" "),_c('profile-attributes-list',{attrs:{"readonly":_vm.readonly},on:{"attribute-updated":_vm.attributeUpdated}}),_vm._v(" "),(_vm.aggregatesEnabled)?_c('profile-aggregates-list',{attrs:{"readonly":_vm.readonly}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1241dc40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profiles/pages/ProfileDataPage.vue
// module id = null
// module chunks = 